import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import './Minerals.css'
import Gettouch from "../../../../components/getTouch/Gettouch";
import talCamImg from '../../../../assets/talCamImg.webp';
import dolomite from '../../../../assets/dolomite.webp';
import calsite from '../../../../assets/calsite.webp';
import chinaClay from '../../../../assets/chinaClay.webp';
import silica from '../../../../assets/silica.webp';
import quartzPowder from '../../../../assets/quartzPowder.webp';
import hydatedLime from '../../../../assets/hydatedLime.webp';
import calCarbonate from '../../../../assets/calCarbonate.webp';

const mineralsData = {
    'Talc Powder': {
        description: (
            <>
                Talc Powder, also known as Talcum Powder, is a naturally occurring mineral composed primarily of magnesium silicate.
                Known for its softness, it is widely used in the cosmetic industry for its moisture-absorbing properties and smooth texture.
                It is also utilized in pharmaceuticals, ceramics, and paint industries due to its fine powder form and non-toxic nature.
                We specialize in providing premium-grade TalCam for use in <strong>Plastic Industry</strong> & <strong>Master Batch Industry</strong>.
            </>
        ),

        image: require('../../../../assets/talCamImg.webp')
    },
    'Dolomite': {
        description: (
            <>
                Dolomite is a double carbonate of calcium and magnesium, often used in construction, glass manufacturing,
                and steel production due to its strength and chemical stability.
                This mineral is also used as a soil conditioner in agriculture and as a raw material for the production of cement.
                We specialize in providing premium-grade Dolomite for use in <strong>Paint Industry</strong>.
            </>
        ),
        image: require('../../../../assets/dolomite.webp')
    },
    'Calcite': {
        description: (
            <>
                Calcite, also known as Calcium Carbonate, is one of the most common minerals on Earth.
                It is widely used in industries such as cement production, paints, plastics, and agriculture.
                Its whitening and neutralizing properties make it an essential material for a variety of industrial processes, including pH adjustment in water treatment.
                We specialize in providing premium-grade Calsite for use in <strong>Soap Industry</strong>.
            </>
        ),
        image: require('../../../../assets/calsite.webp')
    },
    'China Clay': {
        description: (
            <>
                China Clay, also referred to as Kaolin,
                is a fine, white clay primarily used in the production of ceramics, paper, rubber, and cosmetics.
                Its exceptional chemical resistance, fine texture, and high whiteness make it ideal for use in premium products,
                such as high-quality porcelain and glossy paper finishes.
                We specialize in providing premium-grade China Clay for use in <strong>Soap Industry</strong> & <strong>Adhesive Industry</strong>.
            </>
        ),
        image: require('../../../../assets/chinaClay.webp')
    },
    'Silica': {
        description: (
            <>
                Silica, or silicon dioxide (SiO₂), is one of the most abundant minerals on Earth,
                commonly found in sand, quartz, and other materials.
                It is a crucial component in the <strong>Glass Industry</strong>, as well as in <strong>Foundries</strong> & <strong>Construction</strong>.
                Silica is used for its strength, durability, and resistance to heat and chemical wear.
                We specialize in providing premium-grade Silica for use in <strong>Food Industry</strong> & <strong>Chemical Industry</strong>.
            </>

        ),
        image: require('../../../../assets/silica.webp')
    },
    'Quartz Powder': {
        description: (
            <>
                Quartz Powder is a high-purity form of silica, widely used in industries such as <strong>Glass Manufacturing</strong> ,
                <strong> Ceramics</strong> & <strong>Paint Production</strong>.
                Known for its hardness, clarity, and thermal resistance,
                it plays a critical role in enhancing the quality of these products.
                Its finely ground form is highly valued for its ability to improve the durability and finish of manufactured items.
                We specialize in providing premium-grade Quartz Powder for use in <strong>Food Industry</strong> & <strong>Chemical Industry</strong>.
            </>
        ),
        image: require('../../../../assets/talCamImg.webp')
    },
    'Hydrated Lime': {
        description: (
            <>
                Hydrated Lime, or Calcium Hydroxide, is a fine, dry powder commonly used in water treatment, construction, and agriculture.
                It serves to neutralize acidity in both water and soil, improve soil quality for agricultural purposes,
                and assist in the treatment of wastewater by removing impurities.
            </>
        ),
        image: require('../../../../assets/hydatedLime.webp')
    },
    'Calcium Carbonate': {
        description: (
            <>
                Calcium Carbonate is a versatile mineral with numerous industrial uses,
                including paper production, plastics, construction, and food processing.
                Its ability to neutralize acids, provide whitening effects,
                and act as a filler material makes it an essential compound in manufacturing processes across various industries.
                Calcium Carbonate 80, 85, 90 & 94% .
            </>
        ),
        image: require('../../../../assets/calCarbonate.webp')
    }
};



const Minerals = () => {
    const location = useLocation();
    const [selectedMinerals, setSelectedMinerals] = useState('Talc Powder');

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const itemParam = searchParams.get('item') || searchParams.get('type');
        if (itemParam) {
            const keys = Object.keys(mineralsData);
            const match = keys.find(k => k.toLowerCase().includes(itemParam.toLowerCase()) || itemParam.toLowerCase().includes(k.toLowerCase()));
            if (match) {
                setSelectedMinerals(match);
            }
        }
    }, [location.search]);


    return (
        <>
            <div className="Minerals-Page-Desktop">
                <div className="Minerals-Main-Container">
                    <div className="Minerals-Sub-Container">
                        <h1>Minerals</h1>
                        <p>Minerals are the building blocks of the Earth,
                            playing a vital role in countless natural and industrial processes.
                            These naturally occurring inorganic substances are essential not
                            only to the structure of our planet but also to the functioning of modern society.
                            From strengthening infrastructure to enhancing nutrition and enabling advanced technologies,
                            minerals are at the core of progress. At Chemi-Minerals, we specialize in supplying high-quality,
                            precisely processed minerals that meet the specific requirements of diverse sectors, including construction,
                            agriculture, electronics, pharmaceuticals, and environmental solutions. With a commitment to purity, consistency,
                            and performance, we tailor our mineral solutions by composition, particle size, and packaging format to suit every unique application.
                            Because when it comes to minerals, quality and customization make all the difference.

                        </p>
                    </div>

                    <div className="Minerals-Types-Main-Container">
                        <div className="Minerals-Types-List-Conatiner">
                            <h1>Types Of Minerals</h1>
                            {Object.keys(mineralsData).map((mineralsTypes) => (
                                <h2
                                    key={mineralsTypes}
                                    className={selectedMinerals === mineralsTypes ? 'active-salt' : ''}
                                    onClick={() => setSelectedMinerals(mineralsTypes)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    {mineralsTypes}
                                </h2>
                            ))}
                        </div>

                        <div className="Minerals-Heading-Description-Container">
                            <div className="Minerals-Row-Aline-Container">
                                <img
                                    src={mineralsData[selectedMinerals].image}
                                    alt={selectedMinerals}
                                    className="Minerals-Type-Image"
                                />
                                <div className="Minerals-Content-Container">
                                    <h1>{selectedMinerals}</h1>
                                    <p>{mineralsData[selectedMinerals].description}</p>
                                </div>
                            </div>


                        </div>
                    </div>

                    <Gettouch />
                </div>
            </div>


            <div className="Minerals-Page-Mobile">

                <div className="Minerals-Main-Container">
                    <div className="Minerals-Sub-Container">
                        <h1>Minerals</h1>
                        <p>Minerals are the building blocks of the Earth,
                            playing a vital role in countless natural and industrial processes.
                            These naturally occurring inorganic substances are essential not
                            only to the structure of our planet but also to the functioning of modern society.
                            From strengthening infrastructure to enhancing nutrition and enabling advanced technologies,
                            minerals are at the core of progress. At Chemi-Minerals, we specialize in supplying high-quality,
                            precisely processed minerals that meet the specific requirements of diverse sectors, including construction,
                            agriculture, electronics, pharmaceuticals, and environmental solutions. With a commitment to purity, consistency,
                            and performance, we tailor our mineral solutions by composition, particle size, and packaging format to suit every unique application.
                            Because when it comes to minerals, quality and customization make all the difference.

                        </p>

                        <h2>Types of Minerals</h2>
                        <div className="Minerals-Types-Card-Container-Mobile">
                            <h3>Talc Powder</h3>
                            <img src={talCamImg} alt="talCamImg" className="Minerals-Type-Image" />
                            <p>
                                Talc Powder, also known as Talcum Powder, is a naturally occurring mineral composed primarily of magnesium silicate.
                                Known for its softness, it is widely used in the cosmetic industry for its moisture-absorbing properties and smooth texture.
                                It is also utilized in pharmaceuticals, ceramics, and paint industries due to its fine powder form and non-toxic nature.
                                We specialize in providing premium-grade TalCam for use in <strong>Plastic Industry</strong> & <strong>Master Batch Industry</strong>.

                            </p>
                        </div>
                        <div className="Minerals-Types-Card-Container-Mobile">
                            <h3>Dolomite</h3>
                            <img src={dolomite} alt="dolomite" className="Minerals-Type-Image" />
                            <p>
                                Dolomite is a double carbonate of calcium and magnesium, often used in construction, glass manufacturing,
                                and steel production due to its strength and chemical stability.
                                This mineral is also used as a soil conditioner in agriculture and as a raw material for the production of cement.
                                We specialize in providing premium-grade Dolomite for use in <strong>Paint Industry</strong>.

                            </p>
                        </div>
                        <div className="Minerals-Types-Card-Container-Mobile">
                            <h3>Calcite</h3>
                            <img src={calsite} alt="calsite" className="Minerals-Type-Image" />
                            <p>
                                Calcite, also known as Calcium Carbonate, is one of the most common minerals on Earth.
                                It is widely used in industries such as cement production, paints, plastics, and agriculture.
                                Its whitening and neutralizing properties make it an essential material for a variety of industrial processes, including pH adjustment in water treatment.
                                We specialize in providing premium-grade Calsite for use in <strong>Soap Industry</strong>.

                            </p>
                        </div>
                        <div className="Minerals-Types-Card-Container-Mobile">
                            <h3>China Clay</h3>
                            <img src={chinaClay} alt="chinaClay" className="Minerals-Type-Image" />
                            <p>
                                China Clay, also referred to as Kaolin,
                                is a fine, white clay primarily used in the production of ceramics, paper, rubber, and cosmetics.
                                Its exceptional chemical resistance, fine texture, and high whiteness make it ideal for use in premium products,
                                such as high-quality porcelain and glossy paper finishes.
                                We specialize in providing premium-grade China Clay for use in <strong>Soap Industry</strong> & <strong>Adhesive Industry</strong>.

                            </p>
                        </div>
                        <div className="Minerals-Types-Card-Container-Mobile">
                            <h3>Silica</h3>
                            <img src={silica} alt="silica" className="Minerals-Type-Image" />
                            <p>
                                Silica, or silicon dioxide (SiO₂), is one of the most abundant minerals on Earth,
                                commonly found in sand, quartz, and other materials.
                                It is a crucial component in the <strong>Glass Industry</strong>, as well as in <strong>Foundries</strong> & <strong>Construction</strong>.
                                Silica is used for its strength, durability, and resistance to heat and chemical wear.
                                We specialize in providing premium-grade Silica for use in <strong>Food Industry</strong> & <strong>Chemical Industry</strong>.

                            </p>
                        </div>
                        <div className="Minerals-Types-Card-Container-Mobile">
                            <h3>Quartz Powder</h3>
                            <img src={quartzPowder} alt="quartzPowder" className="Minerals-Type-Image" />
                            <p>
                                Quartz Powder is a high-purity form of silica, widely used in industries such as <strong>Glass Manufacturing</strong> ,
                                <strong> Ceramics</strong> & <strong>Paint Production</strong>.
                                Known for its hardness, clarity, and thermal resistance,
                                it plays a critical role in enhancing the quality of these products.
                                Its finely ground form is highly valued for its ability to improve the durability and finish of manufactured items.
                                We specialize in providing premium-grade Quartz Powder for use in <strong>Food Industry</strong> & <strong>Chemical Industry</strong>.

                            </p>
                        </div>
                        <div className="Minerals-Types-Card-Container-Mobile">
                            <h3>Hydrated Lime</h3>
                            <img src={hydatedLime} alt="hydatedLime" className="Minerals-Type-Image" />
                            <p>
                                Hydrated Lime, or Calcium Hydroxide, is a fine, dry powder commonly used in water treatment, construction, and agriculture.
                                It serves to neutralize acidity in both water and soil, improve soil quality for agricultural purposes,
                                and assist in the treatment of wastewater by removing impurities.

                            </p>
                        </div>
                        <div className="Minerals-Types-Card-Container-Mobile">
                            <h3>Calcium Carbonate</h3>
                            <img src={calCarbonate} alt="calCarbonate" className="Minerals-Type-Image" />
                            <p>
                                Calcium Carbonate is a versatile mineral with numerous industrial uses,
                                including paper production, plastics, construction, and food processing.
                                Its ability to neutralize acids, provide whitening effects,
                                and act as a filler material makes it an essential compound in manufacturing processes across various industries.
                                Calcium Carbonate 80, 85, 90 & 94% .

                            </p>
                        </div>
                    </div>


                    <Gettouch />
                </div>

            </div>
        </>
    )
}
export default Minerals;